// Auth Action Types
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

// Reset Password Action Types
export const VERIFY_RESET_TOKEN_REQUEST = 'VERIFY_RESET_TOKEN_REQUEST';
export const VERIFY_RESET_TOKEN_SUCCESS = 'VERIFY_RESET_TOKEN_SUCCESS';
export const VERIFY_RESET_TOKEN_FAILURE = 'VERIFY_RESET_TOKEN_FAILURE';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';

export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';

// API Endpoints
export const API_ENDPOINTS = {
  LOGIN: '/partners/oem-partners/login',
  LOGOUT: '/partners/oem-partners/logout',
  FORGOT_PASSWORD: '/partners/oem-partners/forgot-password',
  VERIFY_RESET_TOKEN: '/partners/oem-partners/verify-reset',
  COMPLETE_PASSWORD_RESET: '/partners/oem-partners/complete-reset'
};